
import { API_BASE_URL } from '../config/api';
import { isOwnerRole } from '../utils/roles';
const API_URL = API_BASE_URL


const checkResponse = async (response) => {
  if (response.status === 401) {
    localStorage.clear()
    window.location.href = '/'
    throw new Error('Unauthorized')
  }
  if (!response.ok) {
    try {
      const errorData = await response.json()
      const errorMessage = errorData.error || errorData.message || 'Network response was not ok'
      throw new Error(errorMessage)
    } catch (e) {
      throw new Error(response.statusText || 'Network response was not ok')
    }
  }
  return response
}

/**
 * Get authorization headers with token
 * @returns {Object} Headers object with authorization
 */
const getAuthHeaders = () => {
  const activeRole = localStorage.getItem('activeRole')
    let token = null

    if (isOwnerRole(activeRole)) {
      token = localStorage.getItem('ownerToken')
    } else if (activeRole === 'staff') {
      token = localStorage.getItem('staffToken')
    } else {
      // Fallback for backward compatibility
      token = localStorage.getItem('token')
    }
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` })
  }
}

/**
 * Create multi-login executive account
 * @param {Object} data - The multi-login account data
 * @param {string} data.username - Username for the account
 * @param {string} data.password - Password for the account
 * @param {Object} data.permissions - Permissions object with privilege flags
 * @returns {Promise<Object>} Response data from API
 */
export const createMultiLogin = async (data) => {
  try {
    const response = await fetch(`${API_URL}/executive/create`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    })

    await checkResponse(response)

    const responseData = await response.json()
    return responseData
  } catch (error) {
    throw error
  }
}

/**
 * Get list of multi-login accounts
 * @returns {Promise<Object>} List of multi-login accounts
 */
export const getMultiLoginList = async () => {
  try {
    const response = await fetch(`${API_URL}/executive/list`, {
      method: 'GET',
      headers: getAuthHeaders(),
    })

    await checkResponse(response)

    const data = await response.json()
    return data
  } catch (error) {
    throw error
  }
}

/**
 * Update multi-login account
 * @param {string} id - Account ID
 * @param {Object} data - Updated account data
 * @returns {Promise<Object>} Response data from API
 */
export const updateMultiLogin = async (id, data) => {
  try {
    const response = await fetch(`${API_URL}/executive/update/${id}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    })

    await checkResponse(response)

    const responseData = await response.json()
    return responseData
  } catch (error) {
    throw error
  }
}

/**
 * Delete multi-login account
 * @param {string} id - Account ID
 * @returns {Promise<Object>} Response data from API
 */
export const deleteMultiLogin = async (id) => {
  try {
    const response = await fetch(`${API_URL}/executive/delete/${id}`, {
      method: 'DELETE',
      headers: getAuthHeaders(),
    })

    await checkResponse(response)

    const responseData = await response.json()
    return responseData
  } catch (error) {
    throw error
  }
}
